import { ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsBoolean,
  IsDateString,
  IsOptional,
  ValidateIf,
} from 'class-validator'
import { IsAfter, IsNotPast } from '../../../utils/date.validator'

export class UpdateLearningPathTeachingAssignmentDto {
  @ApiPropertyOptional({ description: 'Date de disponibilité' })
  @IsOptional()
  @IsDateString()
  @IsNotPast({
    message: 'La date de disponibilité ne peut pas être dans le passé',
  })
  availableFrom?: string

  @ApiPropertyOptional({ description: "Date d'échéance" })
  @IsOptional()
  @IsDateString()
  @IsNotPast({ message: 'La date limite ne peut pas être dans le passé' })
  @ValidateIf(o => o.availableFrom && o.dueAt)
  @IsAfter('availableFrom', {
    message: 'La date limite doit être après la date de disponibilité',
  })
  dueAt?: string

  @ApiPropertyOptional({ description: 'Visibilité du parcours' })
  @IsOptional()
  @IsBoolean()
  isVisible?: boolean
}
